import { RefreshButton } from "@/components/common/RefreshButton";
import { DeleteOutlined, DownOutlined, EditOutlined, ExportOutlined, ImportOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { RESOURCE_TYPE_USERS } from "./users";
import { useTranslation } from "react-i18next";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceInvalidate } from "@/hooks";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceDelete } from "@/hooks/useResourceDelete";
import { RESOURCE_TYPE_ADDONS } from "./Addons";
import { AddonDetailPanel } from "@/components/addons/Detail";
import { VersionDetailPanel } from "@/components/addons/VersionDetail";
import { CREATE_ADDON, CREATE_VERSION, EDIT_ADDON, EDIT_VERSION, EXPORT_ADDON, IMPORT_ADDON } from "@/pages/addons/AddonRoute";
import { ExportAddon } from "@/components/addons/ExportAddon";
import { useState } from "react";
import { ImportAddon } from "@/components/addons/ImportAddon";
import { edit } from "ace-builds";
import RequireTable from "@/components/addons/RequireTable";
import { InstructionEditor } from "@/components/addons/InstructionEditor";
import { RESOURCE_TYPE_ADDON } from "./addon";
import { t } from "i18next";

const RESOURCE = RESOURCE_TYPE_ADDONS;

export const AddonsDetailTabs = [
  { key: "details", label: "Detail", children: <AddonDetailPanel/> },
];

export const AddonDetailTabs = [
  { key: "details", label: "Detail", children: <VersionDetailPanel/> },
];

export const MODULE_LEFT_COLS = [
  "id", "type", "name", "version", "platforms", "connector_name", "aiops_image_version", "aiops_module_name", "deployment_configs"
];


export const MODULE_RIGHT_COLS = [
  "requires", "values", "default_override"
];

export const HELM_LEFT_COLS = [
  "id", "type", "name", "version", "helm_repos_name", "image_repos_name"
];


export const HELM_RIGHT_COLS = [
  "requires", "values", "default_override"
];

export const INFRA_LEFT_COLS = [
  "id", "type", "name", "version"
];

export const INFRA_RIGHT_COLS = [
  "requires", "values"
];

export const ADDON_LEFT_COLS = [
  "id", "type", "name", "category", "provider", "order"
];

export const ADDON_RIGHT_COLS = [
  "versions", "description"
];

export const ADDON_TYPE_ENUM = {
  "module": { text: "Module" },
  "helm": { text: "Helm" },
  "infra": { text: "Infra" },
};

export const getAddonSchema = (editable, isModify) => {
  const schema = [];

  if(!editable) {
    const id = {
      title: "ID",
      dataIndex: "id",
      valueType: 'text',
      renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })
    };
    schema.push(id);
  }

  let type = {
    i18nTitle: "config.addon.type",
    title: "Type",
    dataIndex: "type",
    valueType: "select",
    valueEnum: ADDON_TYPE_ENUM,
    width: "md"
    // formItemProps: {
    //   rules: [{
    //     required: true,
    //     message: t("config.addon.type.required", "This is a required field."),
    //   }],
    // },
  };
  if(!editable) {
    type = {...type, renderFormItem:((item,_, form ) => {
      return (<div>{form.getFieldValue(item.dataIndex)}</div>)
    })}
  }
  schema.push(type);
  
  let name = {
    i18nTitle: "config.addon.name",
    title: "Name",
    dataIndex: "name",
    valueType: 'text',
    width: "md"
  }
  if(editable) {
    if(isModify) {
      name = {...name, fieldProps: {
        readOnly: true}
      }
    }
  } else {
    name = {...name, renderFormItem:((item,_, form ) => {
      return (<div>{form.getFieldValue(item.dataIndex)}</div>)
    })};
  }
  schema.push(name);

  let category = {
    i18nTitle: "config.addon.category",
    title: "Category",
    dataIndex: "category",
    valueType: 'text',
    width: "md"
  };
  
  if(!editable) {
    category = {...category, renderFormItem:((item,_, form ) => {
      return (<div>{form.getFieldValue(item.dataIndex)}</div>)
    })};
  }
  schema.push(category);
  
  let provider = {
    i18nTitle: "config.addon.provider",
    title: "Provider",
    dataIndex: "provider",
    valueType: 'text',
    width: "md"
  }
  if(!editable) {
    provider = {...provider, renderFormItem:((item,_, form ) => {
      return (<div>{form.getFieldValue(item.dataIndex)}</div>)
    })};
  }
  schema.push(provider);

  let order = {
    i18nTitle: "config.addon.order",
    title: "Order",
    dataIndex: "order",
    valueType: 'digit'
  }
  if(!editable) {
    order = {...order, renderFormItem:((item,_, form ) => {
      return (<div>{ form.getFieldValue(item.dataIndex) }</div>)
    })};
  }
  schema.push(order);
  if(!editable) {
    let versions = {
      i18nTitle: "config.addon.versions",
      title: "Versions",
      dataIndex: "versions",
      valueType:  "textarea",
      fieldProps: {
        readOnly: true,
        style: {resize: 'none'}
      },
    }
    schema.push(versions);
  }

  let desc = {
    i18nTitle: "config.addon.description",
    title: "Description",
    dataIndex: "desc",
    valueType: "textarea",
    fieldProps: {
      readOnly: true,
      style: {resize: 'none'}
    },
  }

  if(editable) {
    desc = {...desc, fieldProps: {
      style: {resize: 'none'}
    }}
  }
  schema.push(desc);
  return schema;
};

export const getAddonVersionSchema = (type, editable, isModify) => {
  const schema = [];

  if(!editable) {
    const id = {
      title: "ID",
      dataIndex: "id",
      valueType: 'text',
      renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })
    };
    schema.push(id);
    const type = {
      title: "Type",
      dataIndex: "type",
      valueType: 'text',
      renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })
    }
    schema.push(type);
    const name = {
      title: "Name",
      dataIndex: "name",
      valueType: 'text',
      renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })
    }
    schema.push(name);
  }
  let version = {
    i18nTitle: "addon.version",
    title: "Version",
    dataIndex: "version",
    width: "md"
  };
  
  if(editable) {
    if(isModify) {
      version = {...version, fieldProps: {
        readOnly: true}}
    }
  } else {
    version = {...version, renderFormItem:((item,_, form ) => {
      return (<div>{form.getFieldValue(item.dataIndex)}</div>)
    })};
  }
  schema.push(version);

  if(type == "helm") {
    let helmName = {
      i18nTitle: "addon.helm.name",
      title: "Helm Name",
      dataIndex: "helm_repos_name",
      width: "md"
    }
    if(!editable) {
      helmName = {...helmName, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }
    schema.push(helmName);

    let imageName = {
      i18nTitle: "addon.image.name",
      title: "Image Name",
      dataIndex: "image_repos_name",
      width: "md"
    }
    if(!editable) {
      imageName = {...imageName, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }
    schema.push(imageName);
  }
  
  if(type === "module") {
    let imageVersion = {
      i18nTitle: "addon.version.image",
      title: "Image Version",
      dataIndex: "aiops_image_version",
      width: "md"
    }
    if(!editable) {
      imageVersion = {...imageVersion, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }

    schema.push(imageVersion);

    let supportedPlatforms = {
      i18nTitle: "addon.version.platforms",
      title: "Supported Platforms",
      dataIndex: "platforms",
      width: "md"
    }
    if(!editable) {
      supportedPlatforms = {...supportedPlatforms, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }

    schema.push(supportedPlatforms);

    let connector = {
      i18nTitle: "addon.version.connector",
      title: "Connector",
      dataIndex: "connector_name",
      width: "md"
    }
    if(!editable) {
      connector = {...connector, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }

    schema.push(connector);

    let module = {
      i18nTitle: "addon.version.module",
      title: "Module",
      dataIndex: "aiops_module_name",
      width: "md",
    };

    if(!editable) {
      module = {...module, renderFormItem:((item,_, form ) => {
        return (<div>{form.getFieldValue(item.dataIndex)}</div>)
      })};
    }

    schema.push(module);

    let modules = {
      i18nTitle: "addon.version.modules",
      title: "Modules",
      dataIndex: "deployment_configs",
      width: "md",
      valueType: "textarea",
      fieldProps: {
        placeholder: "",
        style: { resize: "none" }
      },
    };

    if(!editable) {
      modules = {...modules, fieldProps: {
        readOnly: true,
        placeholder: "",
        style: { resize: "none" }
      },}
    }

    schema.push(modules);
  }

  let requires = {
    i18nTitle: "addon.version.requires",
    title: "Requires",
    dataIndex: "requires",
    width: "md",
    valueType:  "custom", 
    renderFormItem: ((item,_, form ) => {
      let ds = [];
      try {
        ds = JSON.parse(form.getFieldValue("requires") || "[]");
      } catch(e) {
        
      }
      return <RequireTable editable={editable} dataSource= {ds} formRef={form}/>
    })
  };
  schema.push(requires);

  let instruction = {
    i18nTitle: "addon.version.instruction",
    title: "Instruction",
    dataIndex: "values",
    width: "md",
  }

  if(editable) {
    instruction = {...instruction, valueType:  "custom", renderFormItem: ((item,_, form ) => {
      return <InstructionEditor content={form.getFieldValue("values") || ""} formRef={form}/>
    })};
  } else {
    instruction = {...instruction, 
      valueType:  "textarea",
      fieldProps: {
        readOnly: true,
        placeholder: "",
        rows: 6,
        style: { resize: "none","width": "100%" }
      }
    };
  }
  schema.push(instruction);

  if(type !== "infra") {
    let dc = {
      i18nTitle: "addon.version.dc",
      title: "Default Config",
      dataIndex: "default_override",
      width: "md",
      valueType: "textarea",
      fieldProps: {
        placeholder: "",
        style: { resize: "none", width: '100%' }
      },
    };

    if(!editable) {
      dc = {...dc , fieldProps: {
        readOnly: true,
        placeholder: "",
        style: { resize: "none", "width": "100%" }
      }};
    }
    schema.push(dc);
  }
  return schema;
};

export const AddonsActions = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const invalidate = useResourceInvalidate();
  const [exportVisible, setExportVisible] = useState(false);
  const [importVisible, setImportVisible] = useState(false);
  const { mutateAsync: deleteMutateAsync } = useResourceDelete();

  const navigateToCreation = () => {
    navigate({ resource: "settings/" + RESOURCE , action: CREATE_ADDON});
  };

  const { state } = useResourceContext();
  const [selectedAddon] = state.selectedResources;

  const actionsMenu = [
    {
      key: "edit",
      label: t("actions.edit", "Edit"),
      icon: <EditOutlined />,
    },
    {
      key: "delete",
      label: t("actions.delete", "Delete"),
      icon: <DeleteOutlined />,
    },
    {
      key: "export",
      label: t("actions.export", "Export"),
      icon: <ExportOutlined />,
    },
    {
      key: "import",
      label: t("actions.import", "Import"),
      icon: <ImportOutlined />,
    },
  ];

  const onClickAction = async (action) => {
    console.log("Action clicked", action);
    switch (action.key) {
      case "edit":
        navigate({ resource: "settings/" + RESOURCE , action: EDIT_ADDON, key: selectedAddon.id });
        break;
      case "delete":
        await deleteMutateAsync({ resource: RESOURCE, id: selectedAddon.id });
        break;
      case "import":
        navigate({ resource: "settings/" + RESOURCE , action: IMPORT_ADDON, key: selectedAddon.id });
        break;
      case "export":
        navigate({ resource: "settings/" + RESOURCE , action: EXPORT_ADDON, key: selectedAddon.id });
        break;
      default:
        console.log("Unknown action", action);
    }
  };

  return [
    <Dropdown
      key="actions"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("instances.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Button key='launch' icon={<PlusCircleOutlined />} onClick={navigateToCreation}>{t('addons.menu.create', "Create Add-on")}</Button>,
    <RefreshButton key='refresh' onClick={() => {
      invalidate({
        resource: RESOURCE,
        invalidates: ["list"],
      });
    }}/>,
    <ExportAddon addonId={selectedAddon?.id} visible={exportVisible} setVisible={setExportVisible}/>,
    <ImportAddon visible={importVisible} setVisible={setImportVisible}/>
  ];
};

export const AddonVersionActions = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const invalidate = useResourceInvalidate();
  const { mutateAsync: deleteMutateAsync } = useResourceDelete();

  const navigateToCreation = () => {
    navigate({ resource: "settings/" + RESOURCE , action: CREATE_VERSION, key: selectedAddon.id, queryParam: "?version=" + (selectedAddon.version ? selectedAddon.version : "") });
  };

  const { state } = useResourceContext();
  const [selectedAddon] = state.selectedResources;

  const actionsMenu = [
    {
      key: "edit",
      label: t("actions.edit", "Edit"),
      icon: <EditOutlined />,
    },
    {
      key: "delete",
      label: t("actions.delete", "Delete"),
      icon: <DeleteOutlined />,
    },
  ];

  const onClickAction = async (action) => {
    console.log("Action clicked", action);
    switch (action.key) {
      case "edit":
        navigate({ resource: "settings/" + RESOURCE , action: EDIT_VERSION, key: selectedAddon.id, queryParam: "?version=" + selectedAddon.version });
        break;
      case "delete":
        await deleteMutateAsync({ resource: RESOURCE_TYPE_ADDON, id: selectedAddon.version, values: {addonId: selectedAddon.id, version: selectedAddon.version} });
        break;
      default:
        console.log("Unknown action", action);
    }
  };

  return [
    <Dropdown
      key="actions"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("instances.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Button key='launch' icon={<PlusCircleOutlined />} onClick={navigateToCreation}>{t('addon.menu.create', 'Create Version')}</Button>,
    <RefreshButton key='refresh' onClick={() => {
      invalidate({
        resource: RESOURCE,
        invalidates: ["list"],
      });
    }} />,
  ];
};